export enum MembershipViewModalType {
	CREATE = 'CREATE',
	DELETE = 'DELETE',
	EDIT = 'EDIT'
}
